export const backgroundDimensions = {
  width: 3840,
  height: 1300,
};
